module.exports = __webpack_public_path__ + "img/JD.8db320c1.png";